import { FormikErrors } from 'formik';
import styles from './FilterPanel.module.scss';
import { useMemo } from 'react';
interface Props<T> {
  disabled?: boolean;
  //TODO добавить вариант для филтра групп флота
  value: {
    name?: string;
    values?: Array<string | number>;
  };
  name: keyof T;
  formValues: T;
  formSetField: (
    field: string,
    value: string[] | boolean,
    shouldValidate?: boolean | undefined
  ) => Promise<void> | Promise<FormikErrors<T>>;
}

export const CheckboxOption = <T,>({ disabled, value, name, formValues, formSetField }: Props<T>) => {
  const allValueName = `${String(name)}All` as keyof T;

  const formValuesArray = formValues[name];
  const valuesAll = formValues && formValues[allValueName];

  const isValueChecked: boolean | undefined = useMemo(() => {
    if ('values' in value) {
      return value.values?.every((e: number | string) => Array.isArray(formValuesArray) && formValuesArray.includes(String(e)));
    }
    if ('key' in value) {
      return Array.isArray(formValuesArray) && formValuesArray.includes(String(value.key));
    }
  }, [value, formValues]);

  const inputValues = useMemo(() => {
    if ('values' in value) {
      return value.values?.map((e) => String(e));
    }
    if ('key' in value) {
      return value.key as string;
    }
  }, [value]);

  return (
    <label className={styles.checkboxLabel} aria-disabled={disabled}>
      <input
        disabled={disabled}
        id={name as string}
        type="checkbox"
        name={name as string}
        className={styles.checkboxInput}
        onChange={(value) => {
          const splitted = value.target.value.split(',');

          if (!value.target.checked) {
            if (formValues[allValueName]) formSetField(allValueName as string, false);
            formSetField(
              name as string,
              Array.isArray(formValuesArray) &&
                formValuesArray.filter((val) => {
                  return !splitted.includes(val);
                })
            );
          } else {
            Array.isArray(formValuesArray) &&
              formSetField(
                name as string,
                Array.isArray(splitted) ? [...formValuesArray, ...splitted] : [...formValuesArray, value.target.value]
              );
          }
        }}
        checked={Boolean(valuesAll) || isValueChecked}
        value={inputValues}
      />
      {value.values?.[0] && typeof value.values[0] === 'string'
        ? `${value.name} (${value?.values?.[0]})`
        : value.name}
    </label>
  );
};
